module.exports = __webpack_public_path__ + "img/prev-table-b1.a2c82c0b.webp";